import { container } from "tsyringe"
import { Analytics, MockAnalytics } from "@/services/AnalyticsService"
import {
  OptionDataService,
  ApiDataService
} from "@/services/WebinarDataServices"
export function registerAnalyticsService(useMockAnalytics: boolean) {
  useMockAnalytics
    ? container.register("AnalyticsService", {
        useClass: MockAnalytics
      })
    : container.register("AnalyticsService", {
        useClass: Analytics
      })
}
export function registerWebinarDataService(useOptions: boolean) {
  useOptions
    ? container.register("WebinarDataService", {
        useClass: OptionDataService
      })
    : container.register("WebinarDataService", {
        useClass: ApiDataService
      })
}
